import { parseJSONData } from "../library/helpers";

/**
 * Parse user settings from string or object
 * @param {string|object} settings - User settings as string or object
 * @returns {object} Parsed settings object
 */
export const parseUserSettings = settings => {
  return parseJSONData(settings, {}, "user.settings");
};
